import { render, staticRenderFns } from "./ui-definition-box-component.vue?vue&type=template&id=048e8a10&scoped=true&"
import script from "./ui-definition-box-component.vue?vue&type=script&lang=ts&"
export * from "./ui-definition-box-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-definition-box-component.vue?vue&type=style&index=0&id=048e8a10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e8a10",
  null
  
)

export default component.exports